import React, { useEffect } from 'react';

const Authorize = () => {
  // Set up social sharing meta tags
  useEffect(() => {
    const originalTitle = document.title;
    document.title = "Initiation - WINGO World";
    
    const setMetaTag = (property: string, content: string) => {
      let meta = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    const currentDomain = window.location.origin;
    const imageUrl = `${currentDomain}/daisy_headshot.png`;

    setMetaTag('og:title', 'Authorize Coach DAISY™ Wingo Surveillance');
    setMetaTag('og:description', 'Authorize Coach DAISY™ Wingo Surveillance');
    setMetaTag('og:image', imageUrl);
    setMetaTag('og:url', window.location.href);
    setMetaTag('og:type', 'website');
    setMetaTag('og:image:width', '1200');
    setMetaTag('og:image:height', '630');
    setMetaTag('og:image:type', 'image/png');
    setMetaTag('og:image:alt', 'Coach DAISY™ - WINGO World');
    
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', 'Authorize Coach DAISY™ Wingo Surveillance');
    setMetaTag('twitter:description', 'Authorize Coach DAISY™ Wingo Surveillance');
    setMetaTag('twitter:image', imageUrl);
    setMetaTag('twitter:image:alt', 'Coach DAISY™ - WINGO World');

    return () => {
      document.title = originalTitle;
      const metaTags = document.querySelectorAll('meta[property^="og:"], meta[property^="twitter:"]');
      metaTags.forEach(tag => {
        if (tag.getAttribute('property')?.startsWith('og:') || tag.getAttribute('property')?.startsWith('twitter:')) {
          tag.remove();
        }
      });
    };
  }, []);

  const baseUrl = typeof window !== 'undefined' ? window.location.origin : 'https://wingo.run';
  const stravaAuthorizeUrl = `https://www.strava.com/oauth/authorize?client_id=94661&response_type=code&redirect_uri=${encodeURIComponent(
    `${baseUrl}/api/auth/callback`
  )}&approval_prompt=force&scope=read,activity:read_all`;

  return (
    <div className="container mx-auto px-4 py-10 max-w-2xl">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 sm:p-8">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-3xl font-bold text-gray-900">
            Initiation
          </h1>
          <span className="inline-flex items-baseline text-sm font-semibold text-gray-600">
            <span className="text-[#E6C200] font-bold">W</span>
            <span>INGO</span>
          </span>
        </div>
        
        <section className="space-y-3 mb-8">
          <p className="text-gray-700 leading-relaxed">
            To start mining, complete 1 Initiation Wingo at <a 
              href="https://www.strava.com/segments/39307521" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-wingo-600 hover:text-wingo-700 font-medium"
            >Wingate Track (1 full 320-meter loop)</a> and text Coach D<span className="text-cyan-600">AI</span>SY™ at <a 
              href="sms:9299254744" 
              className="text-wingo-600 hover:text-wingo-700 font-medium"
             >(929) WAK-GRIG</a> <span className="text-gray-500">(929-925-4744)</span> your receipt (Strava, Garmin, or video).
          </p>
        </section>
        
        <section className="space-y-6 pt-6 border-t border-gray-200">
          <h2 className="text-xl font-bold text-gray-900">Wingo App</h2>
          
          <p className="text-gray-700">
            Authorize the Wingo app to read your Strava activities so Coach D<span className="text-cyan-600">AI</span>SY™ can automatically detect your Wingo segment efforts for the Wingo Challenge.
          </p>
          
          <div className="rounded-2xl bg-gradient-to-br from-gray-50 via-white to-gray-100 border border-gray-200 px-4 py-6 sm:px-6 sm:py-7 text-center space-y-4">
            <p className="text-base text-gray-700">
              Grant the Wingo app read-only access to your Strava activities.
            </p>
            <a
              href={stravaAuthorizeUrl}
              className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-[#E6C200] text-gray-900 font-semibold shadow-sm hover:bg-[#d4b000] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#E6C200] transition-colors"
            >
              Authorize Strava
            </a>
            <p className="text-xs text-gray-500 max-w-md mx-auto">
              Sign in with Strava to authorize. On mobile, Strava may open in your browser. You can revoke access anytime in Strava → Settings → My Apps.
            </p>
          </div>
          
          <p className="text-[8px] text-gray-600 leading-relaxed">
          Coach D<span className="text-cyan-600">AI</span>SY™ receives read-only access to your Strava activities to scan for verified Wingo segment efforts for the Wingo Challenge. The Wingo Challenge is separate from the WINGO ledger and is maintained independently. DAISY cannot post, edit, delete, message, or access anything unrelated to Wingo detection. DAISY stores only a secure refresh token. Access can be revoked at any time from your Strava settings.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Authorize;
